module.exports = __webpack_public_path__ + "static/media/tables.22adbb2a.svg";